<template>
    <div
        :data-component="$options.name"
        class="relative flex flex-col items-center rounded-10 p-16 bg-color-signatur-immo-100 overflow-hidden screen-m:p-24"
    >
        <ms-circle
            v-if="isScreenL"
            class="absolute top-0 left-0"
        />
        <ms-house class="absolute top-[208px] -right-50 screen-m:top-2 screen-m:right-0" />
        <div class="relative text-center screen-m:flex">
            <ms-mail-alert-icon class="mb-16 shrink-0 m-auto screen-m:text-left screen-m:mr-16 screen-m:m-0" />
            <div class="screen-m:text-left">
                <span class="text-h3 font-bold-headline block mb-16 screen-m:mb-8">
                    Du möchtest keine neuen Immobilien mehr verpassen?
                </span>
                <p class="mb-16 text-text-l">
                    Mit unserem kostenlosen Suchauftrag erhältst du die neuesten Angebote per E-Mail. Hast du bereits
                    passende Immobilienangebote gefunden, die du vergleichen möchtest, nutze unsere Merkliste. Weitere
                    Informationen zum Datenschutz findest du
                    <cs-copy-text-link
                        :href="privacyPoliceUrl"
                        target="_blank"
                    >
                        hier</cs-copy-text-link
                    >.
                </p>
            </div>
        </div>
        <div class="relative w-full p-16 bg-white items-center rounded-10 screen-m:flex">
            <div>
                <span class="block mb-8 text-text-l font-bold">Deine Suchkriterien:</span>
                <ms-dynamic-tags
                    :tags="tags"
                    :maxRows="isScreenM ? 1 : 2"
                    class="mb-24 screen-m:mb-0 screen-m:mr-24"
                />
            </div>
            <cs-primary-button
                class="w-full screen-m:w-auto screen-m:shrink-0 screen-m:ml-auto"
                :isCentered="true"
                @click="openModal"
                >Suche abonnieren</cs-primary-button
            >
        </div>
        <ms-mail-agent-modal
            :isVisible="modalIsVisible"
            :trackingVariant="trackingVariant"
            @closeModal="closeModal"
        />
    </div>
</template>
<script lang="ts" src="./MsMailAgentBanner.ts" />
